import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NgSelectModule } from '@ng-select/ng-select';

export interface StringArrayFieldProps {
	/** Present when the schema's `items` are constrained to an enum - renders a closed dropdown instead of free-text tags. */
	options?: string[];
}

/**
 * Renders a `string[]` schema field as a multi-value ng-select instead of
 * FormlyNebularArrayTypeComponent's one-input-row-per-item UI - a much more compact fit for
 * short lists of plain strings (names, keys, etc). Arrays of objects still go through the
 * generic 'array' type since they need full field rendering per item.
 */
@Component({
	selector: 'formly-nebular-string-array',
	template: `
		<ng-select
			[items]="props.options ?? []"
			[multiple]="true"
			[addTag]="!props.options?.length"
			[closeOnSelect]="false"
			[formControl]="formControl"
			[clearSearchOnAdd]="true"
			[closeOnSelect]="!props.options?.length"
			addTagText="Enter to Add Value"
			[placeholder]="props.options?.length ? '' : 'Enter values'"
		></ng-select>
	`,
	imports: [ReactiveFormsModule, NgSelectModule]
})
export class FormlyNebularStringArrayTypeComponent extends FieldType<FieldTypeConfig<StringArrayFieldProps>> {}
